package com.artvending.warden.screens.scanner

import androidx.compose.runtime.Composable
import com.artvending.warden.Column_
import com.artvending.warden.MdCircularProgress
import com.artvending.warden.OutlinedButton
import com.artvending.warden.StackScope
import com.artvending.warden.goHome
import com.artvending.warden.settings
import com.artvending.warden.language
import com.artvending.warden.log
import org.jetbrains.compose.web.css.AlignSelf
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.alignSelf
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginTop
import org.jetbrains.compose.web.css.position
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

@Composable
actual fun Any?.ScannerScreen(model: ScannerScreenModel) {
	if (settings.NEW_GUI) {
		this as StackScope
		
		ScannerScreen_(model)
		return
	}
	
	Column_({ style { flexGrow(1); position(Position.Relative); gap(settings.bigSpace) } }) {
		log("ScannerScreen()--------------")
		Div({ style { } }) {
			Text(language.SCAN_FROM_TABLET)
		}
		
		if (!model.scanner.started) {
			Div({ style { alignSelf(AlignSelf.Center); marginTop(settings.bigSpace * 2) } }) {
				Text(language.LOAD_SCANNER)
			}
			MdCircularProgress { style { alignSelf(AlignSelf.Center); marginBottom(settings.bigSpace * 2) } }
		}
		
		if (model.showScanner)
			model.scanner.ScannerView { code ->
				model.showScanner = false
				model.qrCodeDetected(code)
			}
		
		if (model.scanner.started)
			OutlinedButton({ goHome() }, { style { alignSelf(AlignSelf.Center) } }) {
				Text(language.BACK)
			}
	}
}